module.exports = __webpack_public_path__ + "static/media/profile_default.f031e4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile_default.png
// module id = 2049
// module chunks = 1